// import { useEffect, useState, useRef, useCallback } from "react";
// import {
//   Box,
//   Typography,
//   Skeleton,
//   Chip,
//   Button,
//   Paper,
//   IconButton,
//   Avatar,
// } from "@mui/material";
// import StarIcon from "@mui/icons-material/Star";
// import AccessTimeIcon from "@mui/icons-material/AccessTime";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import PhoneIcon from "@mui/icons-material/Phone";
// import LocalOfferIcon from "@mui/icons-material/LocalOffer";
// import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
// import WhatsAppIcon from "@mui/icons-material/WhatsApp";
// import ScheduleIcon from "@mui/icons-material/Schedule";
// import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";
// import VerifiedIcon from "@mui/icons-material/Verified";
// import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
// import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   selectRestaurantInfo,
//   selectMenuLoading,
//   selectBogoOffers,
//   selectCartOffers,
//   fetchRestaurantDetails,
//   selectRestaurantDetails,
//   selectRestaurantDetailsLoading,
// } from "../../../redux/slices/publicSlice";
// import { getBanner } from "../../../redux/slices/bannerSlice";
// import {
//   fetchOverallStats,
//   selectOverallStats,
// } from "../../../redux/slices/statsSlice";

// const SLIDE_INTERVAL = 3500;

// /* ══════════════════════════════════════════════════════════════════
//    BANNER SLIDER
//    ══════════════════════════════════════════════════════════════════ */
// const BannerSlider = ({ banners, restaurantInfo }) => {
//   const [current, setCurrent] = useState(0);
//   const [loaded, setLoaded] = useState({});
//   const timerRef = useRef(null);
//   const touchStart = useRef(null);
//   const count = banners?.length || 0;
//   const next = useCallback(() => setCurrent((c) => (c + 1) % count), [count]);
//   const prev = useCallback(
//     () => setCurrent((c) => (c - 1 + count) % count),
//     [count],
//   );

//   const resetTimer = useCallback(() => {
//     clearInterval(timerRef.current);
//     if (count > 1) timerRef.current = setInterval(next, SLIDE_INTERVAL);
//   }, [count, next]);

//   useEffect(() => {
//     resetTimer();
//     return () => clearInterval(timerRef.current);
//   }, [resetTimer]);

//   const onTouchStart = (e) => {
//     touchStart.current = e.touches[0].clientX;
//   };
//   const onTouchEnd = (e) => {
//     if (touchStart.current === null) return;
//     const diff = touchStart.current - e.changedTouches[0].clientX;
//     if (Math.abs(diff) > 40) {
//       diff > 0 ? next() : prev();
//       resetTimer();
//     }
//     touchStart.current = null;
//   };

//   if (!count) {
//     return (
//       <Box
//         sx={{
//           position: "relative",
//           height: 200,
//           overflow: "hidden",
//           background: restaurantInfo?.profileImage?.url
//             ? `url(${restaurantInfo.profileImage.url}) center/cover no-repeat`
//             : "linear-gradient(135deg, #1b5e20 0%, #2e7d32 50%, #43a047 100%)",
//         }}
//       >
//         <Box
//           sx={{
//             position: "absolute",
//             inset: 0,
//             background:
//               "linear-gradient(to bottom, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.55) 100%)",
//           }}
//         />
//         {!restaurantInfo?.profileImage?.url && (
//           <>
//             {[
//               { w: 120, h: 120, t: "5%", l: "5%" },
//               { w: 80, h: 80, t: "50%", l: "70%" },
//               { w: 60, h: 60, t: "15%", l: "75%" },
//               { w: 100, h: 100, t: "60%", l: "10%" },
//             ].map((s, i) => (
//               <Box
//                 key={i}
//                 sx={{
//                   position: "absolute",
//                   width: s.w,
//                   height: s.h,
//                   borderRadius: "50%",
//                   bgcolor: "rgba(255,255,255,0.1)",
//                   top: s.t,
//                   left: s.l,
//                 }}
//               />
//             ))}
//           </>
//         )}
//         <Box sx={{ position: "absolute", bottom: 16, left: 16, right: 16 }}>
//           <Typography
//             variant="h5"
//             sx={{
//               color: "white",
//               fontWeight: 800,
//               fontSize: "1.4rem",
//               textShadow: "0 2px 8px rgba(0,0,0,0.4)",
//               mb: 0.5,
//             }}
//           >
//             {restaurantInfo?.restaurantName || "Our Restaurant"}
//           </Typography>
//           {restaurantInfo?.cuisine && (
//             <Typography
//               variant="caption"
//               sx={{ color: "rgba(255,255,255,0.85)", fontSize: "0.78rem" }}
//             >
//               {Array.isArray(restaurantInfo.cuisine)
//                 ? restaurantInfo.cuisine.join(" • ")
//                 : restaurantInfo.cuisine}
//             </Typography>
//           )}
//         </Box>
//       </Box>
//     );
//   }

//   return (
//     <Box
//       sx={{
//         position: "relative",
//         height: 250,
//         overflow: "hidden",
//         bgcolor: "#1b5e20",
//         userSelect: "none",
//       }}
//       onTouchStart={onTouchStart}
//       onTouchEnd={onTouchEnd}
//     >
//       {banners?.map((banner, i) => (
//         <Box
//           key={banner._id}
//           sx={{
//             position: "absolute",
//             inset: 0,
//             opacity: i === current ? 1 : 0,
//             transition: "opacity 0.55s ease",
//             pointerEvents: i === current ? "auto" : "none",
//           }}
//         >
//           {!loaded[banner._id] && (
//             <Skeleton
//               variant="rectangular"
//               width="100%"
//               height="100%"
//               sx={{
//                 position: "absolute",
//                 inset: 0,
//                 zIndex: 1,
//                 bgcolor: "#2e7d32",
//               }}
//             />
//           )}
//           <img
//             src={banner.imageUrl}
//             alt={banner.title || `Banner ${i + 1}`}
//             onLoad={() => setLoaded((p) => ({ ...p, [banner._id]: true }))}
//             onError={() => setLoaded((p) => ({ ...p, [banner._id]: true }))}
//             style={{
//               width: "100%",
//               height: "100%",
//               objectFit: "cover",
//               display: "block",
//               opacity: loaded[banner._id] ? 1 : 0,
//               transition: "opacity 0.3s",
//             }}
//           />
//           <Box
//             sx={{
//               position: "absolute",
//               inset: 0,
//               background:
//                 "linear-gradient(to bottom, rgba(0,0,0,0.02) 0%, rgba(0,0,0,0.45) 100%)",
//             }}
//           />
//           {(banner.title || banner.subtitle) && (
//             <Box sx={{ position: "absolute", bottom: 32, left: 14, right: 40 }}>
//               {banner.title && (
//                 <Typography
//                   sx={{
//                     color: "white",
//                     fontWeight: 800,
//                     fontSize: "1rem",
//                     textShadow: "0 1px 4px rgba(0,0,0,0.5)",
//                     lineHeight: 1.3,
//                     mb: 0.2,
//                   }}
//                 >
//                   {banner.title}
//                 </Typography>
//               )}
//               {banner.subtitle && (
//                 <Typography
//                   sx={{
//                     color: "rgba(255,255,255,0.88)",
//                     fontSize: "0.72rem",
//                     textShadow: "0 1px 3px rgba(0,0,0,0.5)",
//                   }}
//                 >
//                   {banner.subtitle}
//                 </Typography>
//               )}
//             </Box>
//           )}
//         </Box>
//       ))}

//       {count > 1 && (
//         <>
//           <IconButton
//             size="small"
//             onClick={(e) => {
//               e.stopPropagation();
//               prev();
//               resetTimer();
//             }}
//             sx={{
//               position: "absolute",
//               left: 6,
//               top: "50%",
//               transform: "translateY(-50%)",
//               bgcolor: "rgba(0,0,0,0.32)",
//               color: "white",
//               width: 28,
//               height: 28,
//               "&:hover": { bgcolor: "rgba(0,0,0,0.55)" },
//               zIndex: 2,
//             }}
//           >
//             <ArrowBackIosNewIcon sx={{ fontSize: 13 }} />
//           </IconButton>
//           <IconButton
//             size="small"
//             onClick={(e) => {
//               e.stopPropagation();
//               next();
//               resetTimer();
//             }}
//             sx={{
//               position: "absolute",
//               right: 6,
//               top: "50%",
//               transform: "translateY(-50%)",
//               bgcolor: "rgba(0,0,0,0.32)",
//               color: "white",
//               width: 28,
//               height: 28,
//               "&:hover": { bgcolor: "rgba(0,0,0,0.55)" },
//               zIndex: 2,
//             }}
//           >
//             <ArrowForwardIosIcon sx={{ fontSize: 13 }} />
//           </IconButton>
//         </>
//       )}

//       {count > 1 && (
//         <Box
//           sx={{
//             position: "absolute",
//             top: 10,
//             right: 10,
//             bgcolor: "rgba(0,0,0,0.4)",
//             borderRadius: 2,
//             px: 0.8,
//             py: 0.2,
//             zIndex: 2,
//           }}
//         >
//           <Typography
//             sx={{ color: "white", fontSize: "0.65rem", fontWeight: 700 }}
//           >
//             {current + 1}/{count}
//           </Typography>
//         </Box>
//       )}
//     </Box>
//   );
// };

// /* ══════════════════════════════════════════════════════════════════
//    HOME PAGE
//    ══════════════════════════════════════════════════════════════════ */
// const HomePage = ({ restaurantId, onTabChange }) => {
//   const dispatch = useDispatch();
//   const restaurantInfo = useSelector(selectRestaurantInfo);
//   const loading = useSelector(selectMenuLoading);
//   const bogoOffers = useSelector(selectBogoOffers);
//   const cartOffers = useSelector(selectCartOffers);
//   const restaurantDetails = useSelector(selectRestaurantDetails);
//   const restaurantDetailsLoading = useSelector(
//     selectRestaurantDetailsLoading,
//   );
//   const { banners = [] } = useSelector((state) => state.banner || {});
//   const topOffers = [...(cartOffers || []), ...(bogoOffers || [])].slice(0, 3);
//   const restaurant = restaurantDetails || restaurantInfo;

//   /* ── Fetch restaurant details ── */
//   useEffect(() => {
//     if (restaurantId) {
//       dispatch(fetchRestaurantDetails(restaurantId));
//     }
//   }, [dispatch, restaurantId]);

//   /* ── Fetch banners ── */
//   useEffect(() => {
//     if (restaurantId) dispatch(getBanner(restaurantId));
//   }, [dispatch, restaurantId]);

//   /* ── Fetch overall stats ── */
//   const overallStats = useSelector(selectOverallStats);
//   useEffect(() => {
//     dispatch(fetchOverallStats(restaurantId));
//   }, [dispatch, restaurantId]);

//   /* ── Helpers ── */
//   const getDeliveryTimeDisplay = () => {
//     if (restaurant?.deliveryTime) {
//       const { min, max } = restaurant.deliveryTime;
//       return `${min}–${max}`;
//     }
//     return "25–35";
//   };

//   const formatTime = (time) => {
//     if (!time) return "";
//     const [hours, minutes] = time.split(":");
//     const hour = parseInt(hours);
//     const ampm = hour >= 12 ? "PM" : "AM";
//     const hour12 = hour % 12 || 12;
//     return `${hour12}:${minutes} ${ampm}`;
//   };

//   const isCurrentlyOpen = () => {
//     if (!restaurant?.openingTime || !restaurant?.closingTime) return null;
//     const now = new Date();
//     const currentTime = `${now.getHours().toString().padStart(2, "0")}:${now
//       .getMinutes()
//       .toString()
//       .padStart(2, "0")}`;
//     return (
//       currentTime >= restaurant.openingTime &&
//       currentTime <= restaurant.closingTime
//     );
//   };

//   const openStatus = isCurrentlyOpen();

//   const shortAddress = restaurant?.restaurantAddress
//     ? restaurant.restaurantAddress.split(",").slice(0, 2).join(", ")
//     : "";

//   /* ── Derived availability flags ── */
//   const isDeliveryAvailable =
//     !!restaurant?.orderType?.DELIVERY &&
//     !!restaurant?.deliverySettings?.isDeliveryAvailable;

//   const isDineInAvailable =
//     !!restaurant?.orderType?.DINE_IN &&
//     // !!restaurant?.dineIn?.isAvailable &&
//     (restaurant?.dineIn?.totalTables || 0) > 0;

//   const isTakeawayAvailable = !!restaurant?.orderType?.TAKEAWAY;

//   /* ── Google Maps directions URL builder ── */
//   const getDirectionsUrl = () => {
//     const parts = [
//       restaurant?.restaurantAddress,
//       restaurant?.city,
//       restaurant?.state,
//     ].filter((p) => p && p.trim());

//     if (parts.length === 0) return null;

//     const query = encodeURIComponent(parts.join(", "));
//     return `https://www.google.com/maps/dir/?api=1&destination=${query}`;
//   };

//   /* ── Loading state ── */
//   if (loading || restaurantDetailsLoading) {
//     return (
//       <Box sx={{ p: 2 }}>
//         <Skeleton
//           variant="rectangular"
//           height={200}
//           sx={{ borderRadius: 0, mb: 2 }}
//         />
//         <Skeleton variant="text" height={32} width="60%" sx={{ mb: 1 }} />
//         <Skeleton variant="text" height={20} width="40%" sx={{ mb: 2 }} />
//         <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
//           {[1, 2, 3].map((i) => (
//             <Skeleton key={i} variant="rounded" width={80} height={28} />
//           ))}
//         </Box>
//         <Skeleton
//           variant="rectangular"
//           height={100}
//           sx={{ borderRadius: 2, mb: 1 }}
//         />
//         <Skeleton variant="rectangular" height={100} sx={{ borderRadius: 2 }} />
//       </Box>
//     );
//   }

//   /* ── Build stats dynamically ── */
//   const stats = [
//     {
//       key: "rating",
//       icon: <StarIcon sx={{ fontSize: 16, color: "#f59e0b" }} />,
//       value: (() => {
//         const r = Number(overallStats?.averageRating);
//         return !isNaN(r) && r > 0 ? r.toFixed(1) : "New";
//       })(),
//       label: "Rating",
//     },
//     {
//       key: "time",
//       icon: <AccessTimeIcon sx={{ fontSize: 16, color: "#2e7d32" }} />,
//       value: getDeliveryTimeDisplay(),
//       label: "Min",
//     },
//   ];

//   if (
//     isDeliveryAvailable &&
//     restaurant?.deliverySettings?.minOrderAmount?.enabled &&
//     restaurant?.deliverySettings?.minOrderAmount?.amount > 0
//   ) {
//     stats.push({
//       key: "minOrder",
//       icon: <ShoppingBagIcon sx={{ fontSize: 16, color: "#1976d2" }} />,
//       value: `₹${restaurant.deliverySettings.minOrderAmount.amount}`,
//       label: "Min Order",
//     });
//   }

//   return (
//     <Box sx={{ pb: 2, bgcolor: "#f5f5f5", minHeight: "100vh" }}>
//       <BannerSlider banners={banners} restaurantInfo={restaurant} />

//       {/* ═══════════ MAIN INFO CARD ═══════════ */}
//       <Paper
//         elevation={0}
//         sx={{
//           mx: 2,
//           mt: -3,
//           borderRadius: 3,
//           bgcolor: "white",
//           border: "1px solid #f0f0f0",
//           overflow: "hidden",
//           position: "relative",
//           zIndex: 1,
//           boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
//         }}
//       >
//         {/* ── Header: Name + Verified + Open status ── */}
//         <Box
//           sx={{
//             p: 2,
//             display: "flex",
//             alignItems: "center",
//             gap: 1.5,
//             borderBottom: "1px solid #f5f5f5",
//           }}
//         >
//           {restaurant?.profileImage?.url && (
//             <Avatar
//               src={restaurant.profileImage.url}
//               sx={{ width: 56, height: 56, border: "2px solid #2e7d32" }}
//             />
//           )}
//           <Box sx={{ flex: 1, minWidth: 0 }}>
//             <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//               <Typography
//                 variant="h6"
//                 noWrap
//                 sx={{
//                   fontWeight: 800,
//                   fontSize: "1.05rem",
//                   color: "#1a1a1a",
//                 }}
//               >
//                 {restaurant?.restaurantName || "Restaurant"}
//               </Typography>
//               {restaurant?.isVerified && (
//                 <VerifiedIcon sx={{ fontSize: 16, color: "#1976d2" }} />
//               )}
//             </Box>
//             {restaurant?.restaurantAddress && (
//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 0.5,
//                   mt: 0.3,
//                 }}
//               >
//                 <LocationOnIcon sx={{ fontSize: 12, color: "#888" }} />
//                 <Typography
//                   variant="caption"
//                   noWrap
//                   sx={{ color: "#666", fontSize: "0.72rem" }}
//                 >
//                   {shortAddress || "Location not available"}
//                 </Typography>
//               </Box>
//             )}
//           </Box>
//           {openStatus !== null && (
//             <Chip
//               label={openStatus ? "Open" : "Closed"}
//               size="small"
//               sx={{
//                 bgcolor: openStatus ? "#e8f5e9" : "#ffebee",
//                 color: openStatus ? "#2e7d32" : "#c62828",
//                 fontWeight: 700,
//                 fontSize: "0.68rem",
//                 height: 22,
//               }}
//             />
//           )}
//         </Box>

//         {/* ── Stats Row (dynamic) ── */}
//         <Box
//           sx={{
//             display: "grid",
//             gridTemplateColumns: `repeat(${stats.length}, 1fr)`,
//             borderBottom: "1px solid #f5f5f5",
//           }}
//         >
//           {stats.map(({ key, icon, value, label }) => (
//             <Box
//               key={key}
//               sx={{
//                 py: 1.5,
//                 textAlign: "center",
//                 borderRight: "1px solid #f5f5f5",
//                 "&:last-child": { borderRight: "none" },
//               }}
//             >
//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   gap: 0.4,
//                   mb: 0.2,
//                 }}
//               >
//                 {icon}
//                 <Typography
//                   sx={{
//                     fontWeight: 700,
//                     fontSize: "0.9rem",
//                     color: "#1a1a1a",
//                   }}
//                 >
//                   {value}
//                 </Typography>
//               </Box>
//               <Typography
//                 variant="caption"
//                 sx={{ color: "#888", fontSize: "0.66rem" }}
//               >
//                 {label}
//               </Typography>
//             </Box>
//           ))}
//         </Box>

//         {/* ═══════════════════════════════════════════════════════════
//             Order Type Availability Chips
//             - Chip tab dikhega jab restaurant us orderType ko support kare
//             - Available: green, Unavailable: orange (line-through nahi)
//            ═══════════════════════════════════════════════════════════ */}
//         {(restaurant?.orderType?.DELIVERY ||
//           restaurant?.orderType?.DINE_IN ||
//           restaurant?.orderType?.TAKEAWAY) && (
//           <Box
//             sx={{
//               px: 2,
//               py: 1.2,
//               display: "flex",
//               gap: 0.8,
//               flexWrap: "wrap",
//               borderBottom: "1px solid #f5f5f5",
//             }}
//           >
//             {/* DELIVERY chip */}
//             {restaurant?.orderType?.DELIVERY && (
//               <Chip
//                 size="small"
//                 label={
//                   isDeliveryAvailable ? "Delivery" : "Delivery (Unavailable)"
//                 }
//                 sx={{
//                   bgcolor: isDeliveryAvailable ? "#e8f5e9" : "#fff8e1",
//                   color: isDeliveryAvailable ? "#2e7d32" : "#e65100",
//                   fontWeight: 700,
//                   fontSize: "0.7rem",
//                   height: 24,
//                   border: isDeliveryAvailable
//                     ? "1px solid #c8e6c9"
//                     : "1px solid #ffe082",
//                 }}
//               />
//             )}

//             {/* DINE-IN chip */}
//             {restaurant?.orderType?.DINE_IN && (
//               <Chip
//                 size="small"
//                 label={
//                   isDineInAvailable ? "Dine-in" : "Dine-in (Closed)"
//                 }
//                 sx={{
//                   bgcolor: isDineInAvailable ? "#e8f5e9" : "#fff8e1",
//                   color: isDineInAvailable ? "#2e7d32" : "#e65100",
//                   fontWeight: 700,
//                   fontSize: "0.7rem",
//                   height: 24,
//                   border: isDineInAvailable
//                     ? "1px solid #c8e6c9"
//                     : "1px solid #ffe082",
//                 }}
//               />
//             )}

//             {/* TAKEAWAY chip */}
//             {restaurant?.orderType?.TAKEAWAY && (
//               <Chip
//                 size="small"
//                 label={isTakeawayAvailable ? "Takeaway" : "Takeaway (Closed)"}
//                 sx={{
//                   bgcolor: isTakeawayAvailable ? "#e8f5e9" : "#fff8e1",
//                   color: isTakeawayAvailable ? "#2e7d32" : "#e65100",
//                   fontWeight: 700,
//                   fontSize: "0.7rem",
//                   height: 24,
//                   border: isTakeawayAvailable
//                     ? "1px solid #c8e6c9"
//                     : "1px solid #ffe082",
//                 }}
//               />
//             )}
//           </Box>
//         )}

//         {/* ── Delivery Highlights (only if delivery available) ── */}
//         {isDeliveryAvailable && (
//           <Box
//             sx={{
//               px: 2,
//               py: 1.5,
//               display: "flex",
//               flexWrap: "wrap",
//               gap: 0.8,
//               borderBottom: "1px solid #f5f5f5",
//             }}
//           >
//             <Chip
//               size="small"
//               icon={
//                 <DeliveryDiningIcon sx={{ fontSize: 14, color: "#2e7d32" }} />
//               }
//               label="Delivery Available"
//               sx={{
//                 bgcolor: "#e8f5e9",
//                 color: "#2e7d32",
//                 fontWeight: 700,
//                 fontSize: "0.7rem",
//                 height: 26,
//                 "& .MuiChip-icon": { color: "#2e7d32" },
//               }}
//             />
//             {restaurant?.deliverySettings?.freeDeliveryThreshold > 0 && (
//               <Chip
//                 size="small"
//                 label={`Free above ₹${restaurant.deliverySettings.freeDeliveryThreshold}`}
//                 sx={{
//                   bgcolor: "#e8f5e9",
//                   color: "#2e7d32",
//                   fontWeight: 700,
//                   fontSize: "0.7rem",
//                   height: 26,
//                 }}
//               />
//             )}
//             {restaurant?.deliverySettings?.deliveryCharge > 0 && (
//               <Chip
//                 size="small"
//                 label={`₹${restaurant.deliverySettings.deliveryCharge} delivery`}
//                 sx={{
//                   bgcolor: "#fff8e1",
//                   color: "#e65100",
//                   fontWeight: 700,
//                   fontSize: "0.7rem",
//                   height: 26,
//                 }}
//               />
//             )}
//           </Box>
//         )}

//         {/* ── Operating Hours ── */}
//         {restaurant?.openingTime && restaurant?.closingTime && (
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               gap: 1,
//               px: 2,
//               py: 1.2,
//               borderBottom: "1px solid #f5f5f5",
//             }}
//           >
//             <ScheduleIcon sx={{ fontSize: 16, color: "#888" }} />
//             <Typography
//               variant="caption"
//               sx={{ color: "#666", fontSize: "0.75rem" }}
//             >
//               {formatTime(restaurant.openingTime)} –{" "}
//               {formatTime(restaurant.closingTime)}
//             </Typography>
//           </Box>
//         )}

//         {/* ── Dine-in detail row ──
//             Tabhi dikhao jab orderType.DINE_IN true ho AND totalTables > 0 ho
//             (isAvailable ho ya na ho — detail info useful hai user ke liye)
//         */}
//         {restaurant?.orderType?.DINE_IN &&
//           restaurant?.dineIn?.totalTables > 0 && (
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 1,
//                 px: 2,
//                 py: 1.2,
//                 borderBottom: "1px solid #f5f5f5",
//               }}
//             >
//               <TableRestaurantIcon
//                 sx={{
//                   fontSize: 16,
//                   color: isDineInAvailable ? "#2e7d32" : "#e65100",
//                 }}
//               />
//               <Typography
//                 variant="caption"
//                 sx={{ color: "#666", fontSize: "0.75rem" }}
//               >
//                 {isDineInAvailable ? (
//                   <>
//                     Dine-in:{" "}
//                     <strong style={{ color: "#1a1a1a" }}>
//                       {restaurant.dineIn.availableTables}/
//                       {restaurant.dineIn.totalTables}
//                     </strong>{" "}
//                     tables available
//                   </>
//                 ) : (
//                   <>
//                     Dine-in currently{" "}
//                     <strong style={{ color: "#e65100" }}>unavailable</strong> —
//                     total{" "}
//                     <strong style={{ color: "#1a1a1a" }}>
//                       {restaurant.dineIn.totalTables}
//                     </strong>{" "}
//                     tables
//                   </>
//                 )}
//               </Typography>
//             </Box>
//           )}

//         {/* ── Contact Actions: Call + WhatsApp + Directions ── */}
//         {(restaurant?.mobile ||
//           restaurant?.whatsappNumber ||
//           restaurant?.restaurantAddress) && (
//           <Box sx={{ display: "flex", gap: 1, p: 2 }}>
//             {restaurant?.mobile && (
//               <Button
//                 fullWidth
//                 size="small"
//                 variant="outlined"
//                 startIcon={<PhoneIcon sx={{ fontSize: 15 }} />}
//                 href={`tel:${restaurant.mobile}`}
//                 sx={{
//                   borderColor: "#e0e0e0",
//                   color: "#1a1a1a",
//                   textTransform: "none",
//                   fontWeight: 600,
//                   fontSize: "0.72rem",
//                   py: 1,
//                   px: 0.5,
//                   "&:hover": {
//                     borderColor: "#1976d2",
//                     bgcolor: "#e3f2fd",
//                   },
//                 }}
//               >
//                 Call
//               </Button>
//             )}
//             {restaurant?.whatsappNumber && (
//               <Button
//                 fullWidth
//                 size="small"
//                 variant="outlined"
//                 startIcon={<WhatsAppIcon sx={{ fontSize: 15 }} />}
//                 href={`https://wa.me/${restaurant.whatsappNumber}`}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 sx={{
//                   borderColor: "#e0e0e0",
//                   color: "#1a1a1a",
//                   textTransform: "none",
//                   fontWeight: 600,
//                   fontSize: "0.72rem",
//                   py: 1,
//                   px: 0.5,
//                   "&:hover": {
//                     borderColor: "#25D366",
//                     bgcolor: "#e8f5e9",
//                   },
//                 }}
//               >
//                 WhatsApp
//               </Button>
//             )}
//             {getDirectionsUrl() && (
//               <Button
//                 fullWidth
//                 size="small"
//                 variant="outlined"
//                 startIcon={<LocationOnIcon sx={{ fontSize: 15 }} />}
//                 onClick={() => {
//                   const url = getDirectionsUrl();
//                   if (url) window.open(url, "_blank", "noopener,noreferrer");
//                 }}
//                 sx={{
//                   borderColor: "#e0e0e0",
//                   color: "#1a1a1a",
//                   textTransform: "none",
//                   fontWeight: 600,
//                   fontSize: "0.72rem",
//                   py: 1,
//                   px: 0.5,
//                   "&:hover": {
//                     borderColor: "#1976d2",
//                     bgcolor: "#e3f2fd",
//                   },
//                 }}
//               >
//                 Directions
//               </Button>
//             )}
//           </Box>
//         )}
//       </Paper>

//       {/* ═══════════ QUICK ACTIONS ═══════════ */}
//       <Box sx={{ px: 2, mt: 2 }}>
//         <Box sx={{ display: "flex", gap: 1 }}>
//           <Button
//             fullWidth
//             variant="contained"
//             startIcon={<RestaurantMenuIcon sx={{ fontSize: 16 }} />}
//             onClick={() => onTabChange(null, 1)}
//             sx={{
//               bgcolor: "#2e7d32",
//               "&:hover": { bgcolor: "#1b5e20" },
//               borderRadius: 2,
//               textTransform: "none",
//               fontWeight: 700,
//               fontSize: "0.82rem",
//               py: 1.3,
//             }}
//           >
//             View Menu
//           </Button>
//           <Button
//             fullWidth
//             variant="outlined"
//             startIcon={<LocalOfferIcon sx={{ fontSize: 16 }} />}
//             onClick={() => onTabChange(null, 2)}
//             sx={{
//               borderColor: "#2e7d32",
//               color: "#2e7d32",
//               "&:hover": { bgcolor: "#e8f5e9", borderColor: "#1b5e20" },
//               borderRadius: 2,
//               textTransform: "none",
//               fontWeight: 700,
//               fontSize: "0.82rem",
//               py: 1.3,
//             }}
//           >
//             Offers
//           </Button>
//         </Box>
//       </Box>

//       {/* ═══════════ ACTIVE OFFERS PREVIEW ═══════════ */}
//       {topOffers.length > 0 && (
//         <Box sx={{ px: 2, mt: 2.5 }}>
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               mb: 1.2,
//             }}
//           >
//             <Typography
//               variant="subtitle1"
//               sx={{ fontWeight: 700, fontSize: "0.95rem" }}
//             >
//               Active Offers
//             </Typography>
//             <Typography
//               variant="caption"
//               sx={{
//                 color: "#2e7d32",
//                 fontWeight: 700,
//                 cursor: "pointer",
//                 fontSize: "0.75rem",
//               }}
//               onClick={() => onTabChange(null, 2)}
//             >
//               View all →
//             </Typography>
//           </Box>
//           <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
//             {topOffers.map((offer, i) => (
//               <Box
//                 key={offer._id || i}
//                 sx={{
//                   p: 1.5,
//                   borderRadius: 2.5,
//                   bgcolor: i % 2 === 0 ? "#e8f5e9" : "#fff8e1",
//                   border: `1px solid ${i % 2 === 0 ? "#c8e6c9" : "#ffe082"}`,
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 1.5,
//                 }}
//               >
//                 <Box
//                   sx={{
//                     width: 40,
//                     height: 40,
//                     borderRadius: 2,
//                     bgcolor: i % 2 === 0 ? "#2e7d32" : "#f59e0b",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     flexShrink: 0,
//                   }}
//                 >
//                   <LocalOfferIcon sx={{ fontSize: 20, color: "white" }} />
//                 </Box>
//                 <Box sx={{ flex: 1, overflow: "hidden" }}>
//                   <Typography
//                     variant="body2"
//                     sx={{
//                       fontWeight: 700,
//                       fontSize: "0.83rem",
//                       color: "#1a1a1a",
//                     }}
//                   >
//                     {offer.title || offer.name || "Special Offer"}
//                   </Typography>
//                   <Typography
//                     variant="caption"
//                     sx={{ color: "#666", fontSize: "0.72rem" }}
//                     noWrap
//                   >
//                     {offer.description ||
//                       (offer.discountType === "PERCENT"
//                         ? `${offer.value}% off`
//                         : offer.discountType === "FLAT"
//                           ? `₹${offer.value} off`
//                           : "Limited time offer")}
//                   </Typography>
//                 </Box>
//                 {offer.offerCode && (
//                   <Chip
//                     label={offer.offerCode}
//                     size="small"
//                     sx={{
//                       fontSize: "0.65rem",
//                       fontWeight: 700,
//                       height: 22,
//                       bgcolor: "white",
//                       border: `1px dashed ${
//                         i % 2 === 0 ? "#2e7d32" : "#f59e0b"
//                       }`,
//                       color: i % 2 === 0 ? "#2e7d32" : "#e65100",
//                     }}
//                   />
//                 )}
//               </Box>
//             ))}
//           </Box>
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default HomePage;

import { useEffect, useState, useRef, useCallback } from "react";
import {
  Box,
  Typography,
  Skeleton,
  Chip,
  Button,
  Paper,
  IconButton,
  Avatar,
  Snackbar,
  Alert,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ScheduleIcon from "@mui/icons-material/Schedule";
import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";
import VerifiedIcon from "@mui/icons-material/Verified";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import ShareIcon from "@mui/icons-material/Share";
import { useDispatch, useSelector } from "react-redux";
import {
  selectRestaurantInfo,
  selectMenuLoading,
  selectBogoOffers,
  selectCartOffers,
  fetchRestaurantDetails,
  selectRestaurantDetails,
  selectRestaurantDetailsLoading,
} from "../../../redux/slices/publicSlice";
import { getBanner } from "../../../redux/slices/bannerSlice";
import {
  fetchOverallStats,
  selectOverallStats,
} from "../../../redux/slices/statsSlice";

const SLIDE_INTERVAL = 3500;

/* ══════════════════════════════════════════════════════════════════
   BANNER SLIDER
   ══════════════════════════════════════════════════════════════════ */
const BannerSlider = ({ banners, restaurantInfo }) => {
  const [current, setCurrent] = useState(0);
  const [loaded, setLoaded] = useState({});
  const timerRef = useRef(null);
  const touchStart = useRef(null);
  const count = banners?.length || 0;
  const next = useCallback(() => setCurrent((c) => (c + 1) % count), [count]);
  const prev = useCallback(
    () => setCurrent((c) => (c - 1 + count) % count),
    [count],
  );

  const resetTimer = useCallback(() => {
    clearInterval(timerRef.current);
    if (count > 1) timerRef.current = setInterval(next, SLIDE_INTERVAL);
  }, [count, next]);

  useEffect(() => {
    resetTimer();
    return () => clearInterval(timerRef.current);
  }, [resetTimer]);

  const onTouchStart = (e) => {
    touchStart.current = e.touches[0].clientX;
  };
  const onTouchEnd = (e) => {
    if (touchStart.current === null) return;
    const diff = touchStart.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) {
      diff > 0 ? next() : prev();
      resetTimer();
    }
    touchStart.current = null;
  };

  if (!count) {
    return (
      <Box
        sx={{
          position: "relative",
          height: 200,
          overflow: "hidden",
          background: restaurantInfo?.profileImage?.url
            ? `url(${restaurantInfo.profileImage.url}) center/cover no-repeat`
            : "linear-gradient(135deg, #1b5e20 0%, #2e7d32 50%, #43a047 100%)",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(to bottom, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.55) 100%)",
          }}
        />
        {!restaurantInfo?.profileImage?.url && (
          <>
            {[
              { w: 120, h: 120, t: "5%", l: "5%" },
              { w: 80, h: 80, t: "50%", l: "70%" },
              { w: 60, h: 60, t: "15%", l: "75%" },
              { w: 100, h: 100, t: "60%", l: "10%" },
            ].map((s, i) => (
              <Box
                key={i}
                sx={{
                  position: "absolute",
                  width: s.w,
                  height: s.h,
                  borderRadius: "50%",
                  bgcolor: "rgba(255,255,255,0.1)",
                  top: s.t,
                  left: s.l,
                }}
              />
            ))}
          </>
        )}
        <Box sx={{ position: "absolute", bottom: 16, left: 16, right: 16 }}>
          <Typography
            variant="h5"
            sx={{
              color: "white",
              fontWeight: 800,
              fontSize: "1.4rem",
              textShadow: "0 2px 8px rgba(0,0,0,0.4)",
              mb: 0.5,
            }}
          >
            {restaurantInfo?.restaurantName || "Our Restaurant"}
          </Typography>
          {restaurantInfo?.cuisine && (
            <Typography
              variant="caption"
              sx={{ color: "rgba(255,255,255,0.85)", fontSize: "0.78rem" }}
            >
              {Array.isArray(restaurantInfo.cuisine)
                ? restaurantInfo.cuisine.join(" • ")
                : restaurantInfo.cuisine}
            </Typography>
          )}
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        position: "relative",
        height: 250,
        overflow: "hidden",
        bgcolor: "#1b5e20",
        userSelect: "none",
      }}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
    >
      {banners?.map((banner, i) => (
        <Box
          key={banner._id}
          sx={{
            position: "absolute",
            inset: 0,
            opacity: i === current ? 1 : 0,
            transition: "opacity 0.55s ease",
            pointerEvents: i === current ? "auto" : "none",
          }}
        >
          {!loaded[banner._id] && (
            <Skeleton
              variant="rectangular"
              width="100%"
              height="100%"
              sx={{
                position: "absolute",
                inset: 0,
                zIndex: 1,
                bgcolor: "#2e7d32",
              }}
            />
          )}
          <img
            src={banner.imageUrl}
            alt={banner.title || `Banner ${i + 1}`}
            onLoad={() => setLoaded((p) => ({ ...p, [banner._id]: true }))}
            onError={() => setLoaded((p) => ({ ...p, [banner._id]: true }))}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
              opacity: loaded[banner._id] ? 1 : 0,
              transition: "opacity 0.3s",
            }}
          />
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              background:
                "linear-gradient(to bottom, rgba(0,0,0,0.02) 0%, rgba(0,0,0,0.45) 100%)",
            }}
          />
          {(banner.title || banner.subtitle) && (
            <Box sx={{ position: "absolute", bottom: 32, left: 14, right: 40 }}>
              {banner.title && (
                <Typography
                  sx={{
                    color: "white",
                    fontWeight: 800,
                    fontSize: "1rem",
                    textShadow: "0 1px 4px rgba(0,0,0,0.5)",
                    lineHeight: 1.3,
                    mb: 0.2,
                  }}
                >
                  {banner.title}
                </Typography>
              )}
              {banner.subtitle && (
                <Typography
                  sx={{
                    color: "rgba(255,255,255,0.88)",
                    fontSize: "0.72rem",
                    textShadow: "0 1px 3px rgba(0,0,0,0.5)",
                  }}
                >
                  {banner.subtitle}
                </Typography>
              )}
            </Box>
          )}
        </Box>
      ))}

      {count > 1 && (
        <>
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              prev();
              resetTimer();
            }}
            sx={{
              position: "absolute",
              left: 6,
              top: "50%",
              transform: "translateY(-50%)",
              bgcolor: "rgba(0,0,0,0.32)",
              color: "white",
              width: 28,
              height: 28,
              "&:hover": { bgcolor: "rgba(0,0,0,0.55)" },
              zIndex: 2,
            }}
          >
            <ArrowBackIosNewIcon sx={{ fontSize: 13 }} />
          </IconButton>
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              next();
              resetTimer();
            }}
            sx={{
              position: "absolute",
              right: 6,
              top: "50%",
              transform: "translateY(-50%)",
              bgcolor: "rgba(0,0,0,0.32)",
              color: "white",
              width: 28,
              height: 28,
              "&:hover": { bgcolor: "rgba(0,0,0,0.55)" },
              zIndex: 2,
            }}
          >
            <ArrowForwardIosIcon sx={{ fontSize: 13 }} />
          </IconButton>
        </>
      )}

      {count > 1 && (
        <Box
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            bgcolor: "rgba(0,0,0,0.4)",
            borderRadius: 2,
            px: 0.8,
            py: 0.2,
            zIndex: 2,
          }}
        >
          <Typography
            sx={{ color: "white", fontSize: "0.65rem", fontWeight: 700 }}
          >
            {current + 1}/{count}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

/* ══════════════════════════════════════════════════════════════════
   HOME PAGE
   ══════════════════════════════════════════════════════════════════ */
const HomePage = ({ restaurantId, onTabChange }) => {
  const dispatch = useDispatch();
  const restaurantInfo = useSelector(selectRestaurantInfo);
  const loading = useSelector(selectMenuLoading);
  const bogoOffers = useSelector(selectBogoOffers);
  const cartOffers = useSelector(selectCartOffers);
  const restaurantDetails = useSelector(selectRestaurantDetails);
  const restaurantDetailsLoading = useSelector(
    selectRestaurantDetailsLoading,
  );
  const { banners = [] } = useSelector((state) => state.banner || {});
  const topOffers = [...(cartOffers || []), ...(bogoOffers || [])].slice(0, 3);
  const restaurant = restaurantDetails || restaurantInfo;

  /* ── Fetch restaurant details ── */
  useEffect(() => {
    if (restaurantId) {
      dispatch(fetchRestaurantDetails(restaurantId));
    }
  }, [dispatch, restaurantId]);

  /* ── Fetch banners ── */
  useEffect(() => {
    if (restaurantId) dispatch(getBanner(restaurantId));
  }, [dispatch, restaurantId]);

  /* ── Fetch overall stats ── */
  const overallStats = useSelector(selectOverallStats);
  useEffect(() => {
    dispatch(fetchOverallStats(restaurantId));
  }, [dispatch, restaurantId]);

  /* ── Helpers ── */
  const getDeliveryTimeDisplay = () => {
    if (restaurant?.deliveryTime) {
      const { min, max } = restaurant.deliveryTime;
      return `${min}–${max}`;
    }
    return "25–35";
  };

  const formatTime = (time) => {
    if (!time) return "";
    const [hours, minutes] = time.split(":");
    const hour = parseInt(hours);
    const ampm = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minutes} ${ampm}`;
  };

  const isCurrentlyOpen = () => {
    if (!restaurant?.openingTime || !restaurant?.closingTime) return null;
    const now = new Date();
    const currentTime = `${now.getHours().toString().padStart(2, "0")}:${now
      .getMinutes()
      .toString()
      .padStart(2, "0")}`;
    return (
      currentTime >= restaurant.openingTime &&
      currentTime <= restaurant.closingTime
    );
  };

  const openStatus = isCurrentlyOpen();

  const shortAddress = restaurant?.restaurantAddress
    ? restaurant.restaurantAddress.split(",").slice(0, 2).join(", ")
    : "";

  /* ── Derived availability flags ── */
  const isDeliveryAvailable =
    !!restaurant?.orderType?.DELIVERY &&
    !!restaurant?.deliverySettings?.isDeliveryAvailable;

  const isDineInAvailable =
    !!restaurant?.orderType?.DINE_IN &&
    (restaurant?.dineIn?.totalTables || 0) > 0;

  const isTakeawayAvailable = !!restaurant?.orderType?.TAKEAWAY;

  /* ── Share handler ── */
  const [shareSnackbar, setShareSnackbar] = useState({
    open: false,
    message: "",
  });

  const handleShare = async () => {
    const identifier = restaurant?.slug || restaurantId;
    const url = `${window.location.origin}/restaurant/${identifier}`;

    const shareData = {
      title: restaurant?.restaurantName || "Check out this restaurant",
      text: `Order from ${restaurant?.restaurantName || "this restaurant"} 🍽️`,
      url,
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
        return;
      }
      await navigator.clipboard.writeText(url);
      setShareSnackbar({ open: true, message: "Link copied to clipboard!" });
    } catch (err) {
      if (err?.name === "AbortError") return;
      try {
        await navigator.clipboard.writeText(url);
        setShareSnackbar({ open: true, message: "Link copied to clipboard!" });
      } catch {
        setShareSnackbar({ open: true, message: "Could not share link" });
      }
    }
  };

  /* ── Google Maps directions URL builder ── */
  const getDirectionsUrl = () => {
    const parts = [
      restaurant?.restaurantAddress,
      restaurant?.city,
      restaurant?.state,
    ].filter((p) => p && p.trim());

    if (parts.length === 0) return null;

    const query = encodeURIComponent(parts.join(", "));
    return `https://www.google.com/maps/dir/?api=1&destination=${query}`;
  };

  /* ── Loading state ── */
  if (loading || restaurantDetailsLoading) {
    return (
      <Box sx={{ p: 2 }}>
        <Skeleton
          variant="rectangular"
          height={200}
          sx={{ borderRadius: 0, mb: 2 }}
        />
        <Skeleton variant="text" height={32} width="60%" sx={{ mb: 1 }} />
        <Skeleton variant="text" height={20} width="40%" sx={{ mb: 2 }} />
        <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
          {[1, 2, 3].map((i) => (
            <Skeleton key={i} variant="rounded" width={80} height={28} />
          ))}
        </Box>
        <Skeleton
          variant="rectangular"
          height={100}
          sx={{ borderRadius: 2, mb: 1 }}
        />
        <Skeleton variant="rectangular" height={100} sx={{ borderRadius: 2 }} />
      </Box>
    );
  }

  /* ── Build stats dynamically ── */
  const stats = [
    {
      key: "rating",
      icon: <StarIcon sx={{ fontSize: 16, color: "#f59e0b" }} />,
      value: (() => {
        const r = Number(overallStats?.averageRating);
        return !isNaN(r) && r > 0 ? r.toFixed(1) : "New";
      })(),
      label: "Rating",
    },
    {
      key: "time",
      icon: <AccessTimeIcon sx={{ fontSize: 16, color: "#2e7d32" }} />,
      value: getDeliveryTimeDisplay(),
      label: "Min",
    },
  ];

  if (
    isDeliveryAvailable &&
    restaurant?.deliverySettings?.minOrderAmount?.enabled &&
    restaurant?.deliverySettings?.minOrderAmount?.amount > 0
  ) {
    stats.push({
      key: "minOrder",
      icon: <ShoppingBagIcon sx={{ fontSize: 16, color: "#1976d2" }} />,
      value: `₹${restaurant.deliverySettings.minOrderAmount.amount}`,
      label: "Min Order",
    });
  }

  return (
    <Box sx={{ pb: 2, bgcolor: "#f5f5f5", minHeight: "100vh" }}>
      <BannerSlider banners={banners} restaurantInfo={restaurant} />

      {/* ═══════════ MAIN INFO CARD ═══════════ */}
      <Paper
        elevation={0}
        sx={{
          mx: 2,
          mt: -3,
          borderRadius: 3,
          bgcolor: "white",
          border: "1px solid #f0f0f0",
          overflow: "hidden",
          position: "relative",
          zIndex: 1,
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        }}
      >
        {/* ── Header: Name + Verified + Open status ── */}
        <Box
          sx={{
            p: 2,
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            borderBottom: "1px solid #f5f5f5",
          }}
        >
          {restaurant?.profileImage?.url && (
            <Avatar
              src={restaurant.profileImage.url}
              sx={{ width: 56, height: 56, border: "2px solid #2e7d32" }}
            />
          )}
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              <Typography
                variant="h6"
                noWrap
                sx={{
                  fontWeight: 800,
                  fontSize: "1.05rem",
                  color: "#1a1a1a",
                }}
              >
                {restaurant?.restaurantName || "Restaurant"}
              </Typography>
              {restaurant?.isVerified && (
                <VerifiedIcon sx={{ fontSize: 16, color: "#1976d2" }} />
              )}
            </Box>
            {restaurant?.restaurantAddress && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  mt: 0.3,
                }}
              >
                <LocationOnIcon sx={{ fontSize: 12, color: "#888" }} />
                <Typography
                  variant="caption"
                  noWrap
                  sx={{ color: "#666", fontSize: "0.72rem" }}
                >
                  {shortAddress || "Location not available"}
                </Typography>
              </Box>
            )}
          </Box>
          {openStatus !== null && (
            <Chip
              label={openStatus ? "Open" : "Closed"}
              size="small"
              sx={{
                bgcolor: openStatus ? "#e8f5e9" : "#ffebee",
                color: openStatus ? "#2e7d32" : "#c62828",
                fontWeight: 700,
                fontSize: "0.68rem",
                height: 22,
              }}
            />
          )}
        </Box>

        {/* ── Stats Row (dynamic) ── */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: `repeat(${stats.length}, 1fr)`,
            borderBottom: "1px solid #f5f5f5",
          }}
        >
          {stats.map(({ key, icon, value, label }) => (
            <Box
              key={key}
              sx={{
                py: 1.5,
                textAlign: "center",
                borderRight: "1px solid #f5f5f5",
                "&:last-child": { borderRight: "none" },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 0.4,
                  mb: 0.2,
                }}
              >
                {icon}
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "0.9rem",
                    color: "#1a1a1a",
                  }}
                >
                  {value}
                </Typography>
              </Box>
              <Typography
                variant="caption"
                sx={{ color: "#888", fontSize: "0.66rem" }}
              >
                {label}
              </Typography>
            </Box>
          ))}
        </Box>

        {/* ═══════════════════════════════════════════════════════════
            Order Type Availability Chips
           ═══════════════════════════════════════════════════════════ */}
        {(restaurant?.orderType?.DELIVERY ||
          restaurant?.orderType?.DINE_IN ||
          restaurant?.orderType?.TAKEAWAY) && (
          <Box
            sx={{
              px: 2,
              py: 1.2,
              display: "flex",
              gap: 0.8,
              flexWrap: "wrap",
              borderBottom: "1px solid #f5f5f5",
            }}
          >
            {/* DELIVERY chip */}
            {restaurant?.orderType?.DELIVERY && (
              <Chip
                size="small"
                label={
                  isDeliveryAvailable ? "Delivery" : "Delivery (Unavailable)"
                }
                sx={{
                  bgcolor: isDeliveryAvailable ? "#e8f5e9" : "#fff8e1",
                  color: isDeliveryAvailable ? "#2e7d32" : "#e65100",
                  fontWeight: 700,
                  fontSize: "0.7rem",
                  height: 24,
                  border: isDeliveryAvailable
                    ? "1px solid #c8e6c9"
                    : "1px solid #ffe082",
                }}
              />
            )}

            {/* DINE-IN chip */}
            {restaurant?.orderType?.DINE_IN && (
              <Chip
                size="small"
                label={isDineInAvailable ? "Dine-in" : "Dine-in (Closed)"}
                sx={{
                  bgcolor: isDineInAvailable ? "#e8f5e9" : "#fff8e1",
                  color: isDineInAvailable ? "#2e7d32" : "#e65100",
                  fontWeight: 700,
                  fontSize: "0.7rem",
                  height: 24,
                  border: isDineInAvailable
                    ? "1px solid #c8e6c9"
                    : "1px solid #ffe082",
                }}
              />
            )}

            {/* TAKEAWAY chip */}
            {restaurant?.orderType?.TAKEAWAY && (
              <Chip
                size="small"
                label={isTakeawayAvailable ? "Takeaway" : "Takeaway (Closed)"}
                sx={{
                  bgcolor: isTakeawayAvailable ? "#e8f5e9" : "#fff8e1",
                  color: isTakeawayAvailable ? "#2e7d32" : "#e65100",
                  fontWeight: 700,
                  fontSize: "0.7rem",
                  height: 24,
                  border: isTakeawayAvailable
                    ? "1px solid #c8e6c9"
                    : "1px solid #ffe082",
                }}
              />
            )}
          </Box>
        )}

        {/* ── Delivery Highlights (only if delivery available) ── */}
        {isDeliveryAvailable && (
          <Box
            sx={{
              px: 2,
              py: 1.5,
              display: "flex",
              flexWrap: "wrap",
              gap: 0.8,
              borderBottom: "1px solid #f5f5f5",
            }}
          >
            <Chip
              size="small"
              icon={
                <DeliveryDiningIcon sx={{ fontSize: 14, color: "#2e7d32" }} />
              }
              label="Delivery Available"
              sx={{
                bgcolor: "#e8f5e9",
                color: "#2e7d32",
                fontWeight: 700,
                fontSize: "0.7rem",
                height: 26,
                "& .MuiChip-icon": { color: "#2e7d32" },
              }}
            />
            {restaurant?.deliverySettings?.freeDeliveryThreshold > 0 && (
              <Chip
                size="small"
                label={`Free above ₹${restaurant.deliverySettings.freeDeliveryThreshold}`}
                sx={{
                  bgcolor: "#e8f5e9",
                  color: "#2e7d32",
                  fontWeight: 700,
                  fontSize: "0.7rem",
                  height: 26,
                }}
              />
            )}
            {restaurant?.deliverySettings?.deliveryCharge > 0 && (
              <Chip
                size="small"
                label={`₹${restaurant.deliverySettings.deliveryCharge} delivery`}
                sx={{
                  bgcolor: "#fff8e1",
                  color: "#e65100",
                  fontWeight: 700,
                  fontSize: "0.7rem",
                  height: 26,
                }}
              />
            )}
          </Box>
        )}

        {/* ── Operating Hours ── */}
        {restaurant?.openingTime && restaurant?.closingTime && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              px: 2,
              py: 1.2,
              borderBottom: "1px solid #f5f5f5",
            }}
          >
            <ScheduleIcon sx={{ fontSize: 16, color: "#888" }} />
            <Typography
              variant="caption"
              sx={{ color: "#666", fontSize: "0.75rem" }}
            >
              {formatTime(restaurant.openingTime)} –{" "}
              {formatTime(restaurant.closingTime)}
            </Typography>
          </Box>
        )}

        {/* ── Dine-in detail row ── */}
        {restaurant?.orderType?.DINE_IN &&
          restaurant?.dineIn?.totalTables > 0 && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                px: 2,
                py: 1.2,
                borderBottom: "1px solid #f5f5f5",
              }}
            >
              <TableRestaurantIcon
                sx={{
                  fontSize: 16,
                  color: isDineInAvailable ? "#2e7d32" : "#e65100",
                }}
              />
              <Typography
                variant="caption"
                sx={{ color: "#666", fontSize: "0.75rem" }}
              >
                {isDineInAvailable ? (
                  <>
                    Dine-in:{" "}
                    <strong style={{ color: "#1a1a1a" }}>
                      {restaurant.dineIn.availableTables}/
                      {restaurant.dineIn.totalTables}
                    </strong>{" "}
                    tables available
                  </>
                ) : (
                  <>
                    Dine-in currently{" "}
                    <strong style={{ color: "#e65100" }}>unavailable</strong> —
                    total{" "}
                    <strong style={{ color: "#1a1a1a" }}>
                      {restaurant.dineIn.totalTables}
                    </strong>{" "}
                    tables
                  </>
                )}
              </Typography>
            </Box>
          )}

        {/* ── Contact Actions: Call + WhatsApp + Directions ── */}
        {(restaurant?.mobile ||
          restaurant?.whatsappNumber ||
          restaurant?.restaurantAddress) && (
          <Box sx={{ display: "flex", gap: 1, p: 2 }}>
            {restaurant?.mobile && (
              <Button
                fullWidth
                size="small"
                variant="outlined"
                startIcon={<PhoneIcon sx={{ fontSize: 15 }} />}
                href={`tel:${restaurant.mobile}`}
                sx={{
                  borderColor: "#e0e0e0",
                  color: "#1a1a1a",
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "0.72rem",
                  py: 1,
                  px: 0.5,
                  "&:hover": {
                    borderColor: "#1976d2",
                    bgcolor: "#e3f2fd",
                  },
                }}
              >
                Call
              </Button>
            )}
            {restaurant?.whatsappNumber && (
              <Button
                fullWidth
                size="small"
                variant="outlined"
                startIcon={<WhatsAppIcon sx={{ fontSize: 15 }} />}
                href={`https://wa.me/${restaurant.whatsappNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  borderColor: "#e0e0e0",
                  color: "#1a1a1a",
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "0.72rem",
                  py: 1,
                  px: 0.5,
                  "&:hover": {
                    borderColor: "#25D366",
                    bgcolor: "#e8f5e9",
                  },
                }}
              >
                WhatsApp
              </Button>
            )}
            {getDirectionsUrl() && (
              <Button
                fullWidth
                size="small"
                variant="outlined"
                startIcon={<LocationOnIcon sx={{ fontSize: 15 }} />}
                onClick={() => {
                  const url = getDirectionsUrl();
                  if (url) window.open(url, "_blank", "noopener,noreferrer");
                }}
                sx={{
                  borderColor: "#e0e0e0",
                  color: "#1a1a1a",
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "0.72rem",
                  py: 1,
                  px: 0.5,
                  "&:hover": {
                    borderColor: "#1976d2",
                    bgcolor: "#e3f2fd",
                  },
                }}
              >
                Directions
              </Button>
            )}
          </Box>
        )}
      </Paper>

      {/* ═══════════ QUICK ACTIONS ═══════════ */}
      {/* <Box sx={{ px: 2, mt: 2 }}>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button
            fullWidth
            variant="contained"
            startIcon={<RestaurantMenuIcon sx={{ fontSize: 16 }} />}
            onClick={() => onTabChange(null, 1)}
            sx={{
              bgcolor: "#2e7d32",
              "&:hover": { bgcolor: "#1b5e20" },
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 700,
              fontSize: "0.78rem",
              py: 1.3,
              flex: 1.2,
            }}
          >
            View Menu
          </Button>
          <Button
            fullWidth
            variant="outlined"
            startIcon={<LocalOfferIcon sx={{ fontSize: 16 }} />}
            onClick={() => onTabChange(null, 2)}
            sx={{
              borderColor: "#2e7d32",
              color: "#2e7d32",
              "&:hover": { bgcolor: "#e8f5e9", borderColor: "#1b5e20" },
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 700,
              fontSize: "0.78rem",
              py: 1.3,
              flex: 1,
            }}
          >
            Offers
          </Button>
          <Button
            variant="outlined"
            onClick={handleShare}
            aria-label="Share restaurant"
            sx={{
              minWidth: 46,
              borderColor: "#2e7d32",
              color: "#2e7d32",
              borderRadius: 2,
              px: 1.2,
              py: 1.3,
              "&:hover": { bgcolor: "#e8f5e9", borderColor: "#1b5e20" },
            }}
          >
            <ShareIcon sx={{ fontSize: 18 }} />
          </Button>
        </Box>
      </Box> */}

      {/* ═══════════ QUICK ACTIONS ═══════════ */}
<Box sx={{ px: 2, mt: 2 }}>
  <Box sx={{ display: "flex", gap: 1.2 }}>
    {/* ── View Menu ── */}
    <Button
      variant="contained"
      disableElevation
      startIcon={<RestaurantMenuIcon sx={{ fontSize: 18 }} />}
      onClick={() => onTabChange(null, 1)}
      sx={{
        flex: 1.4,
        borderRadius: 3,
        textTransform: "none",
        fontWeight: 700,
        fontSize: "0.85rem",
        letterSpacing: 0.2,
        py: 1.4,
        px: 2,
        color: "#fff",
        background: "linear-gradient(135deg, #2e7d32 0%, #43a047 100%)",
        boxShadow: "0 6px 16px rgba(46, 125, 50, 0.32)",
        position: "relative",
        overflow: "hidden",
        transition: "all 0.25s ease",
        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(135deg, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0) 60%)",
          opacity: 0,
          transition: "opacity 0.25s ease",
        },
        "&:hover": {
          background: "linear-gradient(135deg, #1b5e20 0%, #2e7d32 100%)",
          boxShadow: "0 8px 22px rgba(46, 125, 50, 0.45)",
          transform: "translateY(-2px)",
          "&::before": { opacity: 1 },
        },
        "&:active": {
          transform: "translateY(0)",
          boxShadow: "0 4px 10px rgba(46, 125, 50, 0.3)",
        },
      }}
    >
      View Menu
    </Button>

    {/* ── Offers ── */}
    <Button
      variant="outlined"
      disableElevation
      startIcon={<LocalOfferIcon sx={{ fontSize: 18 }} />}
      onClick={() => onTabChange(null, 2)}
      sx={{
        flex: 1,
        borderRadius: 3,
        textTransform: "none",
        fontWeight: 700,
        fontSize: "0.85rem",
        letterSpacing: 0.2,
        py: 1.4,
        px: 2,
        border: "1.5px solid #2e7d32",
        color: "#2e7d32",
        bgcolor: "#fff",
        boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
        transition: "all 0.25s ease",
        "&:hover": {
          borderColor: "#1b5e20",
          bgcolor: "#e8f5e9",
          color: "#1b5e20",
          boxShadow: "0 6px 16px rgba(46, 125, 50, 0.18)",
          transform: "translateY(-2px)",
        },
        "&:active": {
          transform: "translateY(0)",
          boxShadow: "0 2px 6px rgba(46, 125, 50, 0.12)",
        },
      }}
    >
      Offers
    </Button>

    {/* ── Share ── */}
    <Button
      variant="outlined"
      disableElevation
      onClick={handleShare}
      aria-label="Share restaurant"
      sx={{
        minWidth: 52,
        width: 52,
        height: "auto",
        borderRadius: 3,
        p: 0,
        border: "1.5px solid #2e7d32",
        color: "#2e7d32",
        bgcolor: "#fff",
        boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
        transition: "all 0.25s ease",
        "&:hover": {
          borderColor: "#1b5e20",
          bgcolor: "#e8f5e9",
          color: "#1b5e20",
          boxShadow: "0 6px 16px rgba(46, 125, 50, 0.18)",
          transform: "translateY(-2px) rotate(-8deg)",
        },
        "&:active": {
          transform: "translateY(0) rotate(0deg)",
        },
      }}
    >
      <ShareIcon sx={{ fontSize: 20 }} />
    </Button>
  </Box>
</Box>

      {/* ═══════════ ACTIVE OFFERS PREVIEW ═══════════ */}
      {topOffers.length > 0 && (
        <Box sx={{ px: 2, mt: 2.5 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1.2,
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 700, fontSize: "0.95rem" }}
            >
              Active Offers
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: "#2e7d32",
                fontWeight: 700,
                cursor: "pointer",
                fontSize: "0.75rem",
              }}
              onClick={() => onTabChange(null, 2)}
            >
              View all →
            </Typography>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            {topOffers.map((offer, i) => (
              <Box
                key={offer._id || i}
                sx={{
                  p: 1.5,
                  borderRadius: 2.5,
                  bgcolor: i % 2 === 0 ? "#e8f5e9" : "#fff8e1",
                  border: `1px solid ${i % 2 === 0 ? "#c8e6c9" : "#ffe082"}`,
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                }}
              >
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: 2,
                    bgcolor: i % 2 === 0 ? "#2e7d32" : "#f59e0b",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <LocalOfferIcon sx={{ fontSize: 20, color: "white" }} />
                </Box>
                <Box sx={{ flex: 1, overflow: "hidden" }}>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 700,
                      fontSize: "0.83rem",
                      color: "#1a1a1a",
                    }}
                  >
                    {offer.title || offer.name || "Special Offer"}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{ color: "#666", fontSize: "0.72rem" }}
                    noWrap
                  >
                    {offer.description ||
                      (offer.discountType === "PERCENT"
                        ? `${offer.value}% off`
                        : offer.discountType === "FLAT"
                          ? `₹${offer.value} off`
                          : "Limited time offer")}
                  </Typography>
                </Box>
                {offer.offerCode && (
                  <Chip
                    label={offer.offerCode}
                    size="small"
                    sx={{
                      fontSize: "0.65rem",
                      fontWeight: 700,
                      height: 22,
                      bgcolor: "white",
                      border: `1px dashed ${
                        i % 2 === 0 ? "#2e7d32" : "#f59e0b"
                      }`,
                      color: i % 2 === 0 ? "#2e7d32" : "#e65100",
                    }}
                  />
                )}
              </Box>
            ))}
          </Box>
        </Box>
      )}

      {/* ═══════════ SHARE SNACKBAR ═══════════ */}
      <Snackbar
        open={shareSnackbar.open}
        autoHideDuration={2500}
        onClose={() => setShareSnackbar({ open: false, message: "" })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setShareSnackbar({ open: false, message: "" })}
          severity="success"
          variant="filled"
          sx={{
            bgcolor: "#2e7d32",
            fontWeight: 600,
            fontSize: "0.82rem",
            borderRadius: 2,
          }}
        >
          {shareSnackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default HomePage;